__turbopack_context__.v({
  "className": "caveat_d1c15798-module__lCDrBW__className",
});
